import React, { useCallback, useEffect } from "react";

import MapMarker from "../../../models/MapMarker";
import CustomButton from "../../ui/CustomButton";
import { openNavigate } from "../../../helpers/navigation";
import { getAddressFormat, getServiceIcon } from "../../../helpers/formatters";
import useStore from "../../../hooks-store/store";
import { Button, TButtonSize, Tooltip } from "@velocity/ui";
import MapDrawer from "./MapDrawer";
import { localization } from "../../../localization/localizedStrings";
import { EyeopenIcon, LocationIcon } from "@velocity/icons/system";
import { Partner } from "../../../api/Client";
import {LabelImportant} from "@material-ui/icons";

interface MapInfoWindowProps {
  marker: MapMarker;
}

const handleOnNavigationClick = (marker: MapMarker) => {
  if (marker?.partnerInfo?.latitude && marker.partnerInfo?.longitude)
    openNavigate(marker.partnerInfo?.latitude, marker.partnerInfo?.longitude);
};

const MapInfoWindow = ({ marker }: MapInfoWindowProps) => {
  const [, setOpenDrawerStore] = useStore<boolean>(
    "openDrawer",
    false
  );
  const [partnerStore, setPartnerStore] = useStore<Partner | null>(
    "partner",
    null
  );

  const handleOnMoreInfoClick = (e: React.MouseEvent, marker: MapMarker) => {
      e.stopPropagation();
      setOpenDrawerStore(true);
      setPartnerStore(marker.partnerInfo);
  };

  return (
      <div>
          <div className="map-info-window-content">
              <div style={{padding: "0.25rem"}}>
                  {getAddressFormat(marker?.partnerInfo)}
              </div>
              <div className="map-info-window-additional-data">
                  { marker?.partnerInfo?.gsm && (<div style={{padding: "0.25rem"}}>
                      {localization.contactGsm}: &nbsp;
                      <strong>
                          {marker?.partnerInfo?.gsm
                              ?.split(",")
                              .map((gsm, idx) => {
                                  const trimmedGsm = gsm.trim();
                                  const hrefGsm = trimmedGsm.replace(/\s+/g, "");
                                  return trimmedGsm ? (
                                      <React.Fragment key={trimmedGsm + idx}>
                                          <a href={`tel:${hrefGsm}`}>{trimmedGsm}</a>
                                          {idx < marker.partnerInfo.gsm!.split(",").length - 1 && ", "}
                                      </React.Fragment>
                                  ) : null;
                              })}
                      </strong>
                  </div>)}
                  { marker?.partnerInfo?.email && (<div style={{padding: "0.25rem"}}>
                      {localization.contactEmail}:&nbsp;
                      <strong>
                          {marker?.partnerInfo?.email
                              ?.split(",")
                              .map((email, idx) => {
                                  const trimmedEmail = email.trim();
                                  return trimmedEmail ? (
                                      <React.Fragment key={trimmedEmail + idx}>
                                          <a href={`mailto:${trimmedEmail}`}>{trimmedEmail}</a>
                                          {idx < marker.partnerInfo.email!.split(",").length - 1 && ", "}
                                      </React.Fragment>
                                  ) : null;
                              })}
                      </strong>
                  </div>)}
                  { marker?.partnerInfo?.website && (<div style={{padding: "0.25rem"}}>
                      {localization.websSite}:&nbsp;
                      <strong>
                          <a href={`${marker?.partnerInfo?.website}`} target="_blank">
                              {marker?.partnerInfo?.website}
                          </a>
                      </strong>
                  </div>)}
                  { marker?.partnerInfo?.openingHours && (<div style={{padding: "0.25rem"}}>
                      {localization.openingHours}:&nbsp;
                      <strong>{marker?.partnerInfo?.openingHours}</strong>
                  </div>)}




                  {/* <div className="mt-1 mb-1">
            <strong>{localization.filterTitle}</strong>
            <div>
              {marker?.partnerInfo?.servicesCollection?.map((service) => (
                <>
                  <img
                    alt={service?.serviceType?.toString()}
                    src={getServiceIcon(service?.serviceType)}
                  />
                </>
              ))}
            </div>
          </div> */}
              </div>
          </div>
          <h2>{localization.contactUs}</h2>
          <div className="mb-05">
              <CustomButton
                  text={localization.navigate}
                  fullWidth
                  size={"s" as TButtonSize}
                  onClick={() => handleOnNavigationClick(marker)}
                  variant="primary-filled"
                  startIcon={LocationIcon}
              />
          </div>
          <div style={{marginTop: "0.15rem"}}>
              <Button
                  variant="primary-outlined"
                  fullWidth
                  size={"s" as TButtonSize}
                  onClick={(e: React.MouseEvent) => handleOnMoreInfoClick(e, marker)}
                  StartIcon={EyeopenIcon}
              >
                  {localization.moreInformations}
              </Button>
          </div>
          <MapDrawer/>
      </div>
  );
};

export default MapInfoWindow;
